import { ofType } from "redux-observable";
import * as Rx from "rxjs";
import * as RxOp from "rxjs/operators";

export const TOP = "main";
export const SCROLL_TO = "SCROLL_TO";
export const scrollTo = ({ id }) => ({
  type: SCROLL_TO,
  payload: { id },
});

export const scrollToTop = () => scrollTo({ id: TOP });

export const scrollToEpic = (action$) =>
  action$.pipe(
    ofType(SCROLL_TO),
    RxOp.mergeMap(({ payload: { id } }) => {
      setTimeout(() => {
        const elem = document.getElementById(id);
        if (elem) {
          elem.scrollIntoView({ behavior: "smooth" });
        }
      });
      return Rx.empty();
    })
  );

export default scrollToEpic;
